import axios from 'axios';
import {
  EDIT_ANALYTICS_FAIL,
  EDIT_ANALYTICS_LOADING,
  EDIT_ANALYTICS_SUCCESS,
  GET_ANALYTICS_FAIL,
  GET_ANALYTICS_LOADING,
  GET_ANALYTICS_SUCCESS,
} from '../types';

export const getAnalytics = () => async (dispatch) => {
  dispatch({
    type: GET_ANALYTICS_LOADING,
  });
  try {
    const response = await axios.get('/api/analytics');

    dispatch({
      type: GET_ANALYTICS_SUCCESS,
      payload: { items: response.data.items },
    });
  } catch (err) {
    dispatch({
      type: GET_ANALYTICS_FAIL,
      payload: { error: err.message },
    });
  }
};

export const editAnalytics = (formId, payload) => async (dispatch) => {
  dispatch({
    type: EDIT_ANALYTICS_LOADING,
    payload: { formId },
  });
  try {
    const response = await axios.patch(`/api/analytics/${formId}`, payload);
    /*  const response = {
      data: {
        item: {
          form: formId,
          unread: 0,
        },
      },
    }; */
    return dispatch({
      type: EDIT_ANALYTICS_SUCCESS,
      payload: { item: response.data.item, formId },
    });
  } catch (err) {
    return dispatch({
      type: EDIT_ANALYTICS_FAIL,
      payload: { error: err.message, formId },
    });
  }
};
